<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
  </el-config-provider>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElConfigProvider } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { epLang, LANG_ELEMENT_PLUS_MAP, $t } from '@/plugins/i18n';

export default defineComponent({
  name: 'app',
  components: {
    [ElConfigProvider.name]: ElConfigProvider
  },
  computed: {
    currentLocale() {
      const { locale } = useI18n();
      const elementPlusLangKey =
        LANG_ELEMENT_PLUS_MAP[locale.value] || locale.value;
      // console.log(
      //   'langlanglang setVueI18nMessage444',
      //   locale.value,
      //   epLang,
      //   elementPlusLangKey,
      //   epLang[elementPlusLangKey]
      // );
      return epLang[elementPlusLangKey];
    }
  },
  created() {
    document.title = $t('货运平台-运营管理');
  }
});
</script>
